import { __read, __spread } from "tslib";
import { px } from './px';
/**
 * spacing
 * @param values
 */
export function spacing() {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    return function (_a) {
        var theme = _a.theme;
        var unit = theme.spacing(1);
        return px.apply(void 0, __spread(values.map(function (n) { return n * unit; })));
    };
}
export function toSpacing(value) {
    return value / 4;
}
/**
 * spacing unit value
 * @param values
 */
export function spacingUnit(values) {
    return function (_a) {
        var theme = _a.theme;
        var unit = theme.spacing(1);
        return values * unit;
    };
}
